/** @format */

import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges
} from '@angular/core';
import { Review, ReviewMedia, ReviewSelectedMedia } from '@product-reviews/data-access';

@Component({
	selector: 'product-reviews-review-thumbnails',
	templateUrl: './review-thumbnails.component.html',
	styleUrl: './review-thumbnails.component.scss',
	standalone: false
})
export class ReviewThumbnailsComponent implements OnChanges, OnInit {
	@Input() mediaItem: Review;
	@Input() selected: string;
	@Output() mediaSelected = new EventEmitter<ReviewSelectedMedia>();
	medias: ReviewMedia[] = [];
	selectedMedia: ReviewSelectedMedia | null = null;
	ngOnInit() {
		this.medias = this.mediaItem.Media;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.mediaItem) {
			const mediaItem = changes.mediaItem.currentValue;
			this.medias = mediaItem.Media;
		}
	}

	selectMedia(media: ReviewSelectedMedia, imageId: number): void {
		this.selectedMedia = {
			...media,
			imageId
		};
		this.mediaSelected.emit(this.selectedMedia);
	}

	/*
	 * Track media changed
	 */
	trackByMedia(index: number, media: ReviewMedia): string {
		return index.toString() + media.id;
	}
}
